import React from 'react';
import { Step, StepSchema } from '../../services/api/models';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormControl, Grid, IconButton, TextField } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { AddCircle } from '@mui/icons-material';


interface StepAddFormProps {
  onAdd?: (step: Step) => void;
}


export default function StepAddForm(props: StepAddFormProps) {

  const methods = useForm<Step>({
    resolver: zodResolver(StepSchema), // Apply the zodResolver
    defaultValues: {},
  });
  const {
    register,
    handleSubmit,
    reset,
  } = methods;


  const onSubmit = (step: Step) => {
    if (props.onAdd) {
      props.onAdd(step);
    }
    reset({
      name: '',
      text: '',
    });
  }

  return (
    <FormProvider {...methods}>
        <Grid container>
          <Grid item>
            <DragIndicatorIcon sx={{visibility: 'hidden'}}/>
          </Grid>
          <Grid item xs={11}>
            <FormControl>
              <TextField
                label='Step Name'
                variant='outlined'
                size='small'
                InputLabelProps={{ shrink: true }}
                {...register('name')} />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                label='Instructions'
                multiline
                rows={4}
                variant='outlined'
                size='small'
                InputLabelProps={{ shrink: true }}
                {...register('text')} />
            </FormControl>
          </Grid>
          <Grid item sx={{margin: 'auto'}}>
            <IconButton color="primary" aria-label="upload picture" component="span" size='small' sx={{align: 'right', display: 'flex'}} onClick={handleSubmit(onSubmit)}>
              <AddCircle fontSize='small'/>
            </IconButton>
          </Grid>
        </Grid>
    </FormProvider>
  )
}
